import firebase from 'firebase/app';

export const TimestampToString = (
  timestamp: firebase.firestore.Timestamp
): string => {
  const _date = timestamp.toDate();
  return `${_date.getFullYear()}年${
    _date.getMonth() + 1
  }月${_date.getDate()}日 ${_date.getHours()}:${_date.getMinutes()}:${_date.getSeconds()}`;
};
